module.exports = __webpack_public_path__ + "static/media/nav-eat-out-logo.2d65337c.svg";